module.exports = __webpack_public_path__ + "img/32.01d64ae6.jpg";